import { render, staticRenderFns } from "./LpaPeopleModal.vue?vue&type=template&id=39a6544d"
import script from "./LpaPeopleModal.vue?vue&type=script&lang=js"
export * from "./LpaPeopleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports